import {atom} from 'jotai'

export const snackbarMessagesState = atom([])
